export default __webpack_public_path__ + "static/media/EmptyPointIcone.5f2c77dd.svg";